import type { App } from "@teamworksdev/react";
import { customerFacingApps, getPersonName } from "~/config";
import { DocumentStatus } from "../documents";
import type { Person } from "./types";

export function makePerson(json: any): Person {
  const apps = Object.keys(json._document.app_status ?? {}).map((key) => key as App);

  const activeApps: App[] = [];
  const inactiveApps: App[] = [];
  Object.entries(json._document.app_status ?? {}).forEach(([key, value]) => {
    if (value === DocumentStatus.active) {
      activeApps.push(key as App);
    } else {
      inactiveApps.push(key as App);
    }
  });

  const webAccess: Partial<Record<App, boolean>> = {};
  const mobileAccess: Partial<Record<App, boolean>> = {};

  customerFacingApps.forEach((app) => {
    webAccess[app] = !!json[`${app}HasWebAccess`];
    mobileAccess[app] = !!json[`${app}HasMobileAccess`];
  });

  return {
    _original: json,
    id: json._document.id,
    name: getPersonName(json as Person),
    active: json._document.status,
    apps: apps,
    inactiveApps: inactiveApps,
    appStatus: json._document.app_status,
    givenName: json.givenName,
    preferredName: json.preferredName,
    familyName: json.familyName,
    email: json.email,
    primaryPhone: json.primaryPhone,
    birthDate: json.birthDate,
    clientUniqueId: json.clientUniqueId,
    hubProfileId: json.hubProfileId,
    activeWithoutLoginAccess: json.activeWithoutLoginAccess,
    inflcrProfileId: json.inflcrProfileId,
    imageUrl: json.imageUrl,
    oktaUserId: json.oktaUserId,
    webAccess,
    mobileAccess,
  };
}

export function makePeople(json: any): Person[] {
  return json?.map(makePerson) ?? [];
}

export function makeId(json: any): string {
  return json?.id ?? "";
}
